import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eb44f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "dis_flex" }
const _hoisted_4 = { class: "label_tit" }
const _hoisted_5 = {
  key: 0,
  class: "remark_content"
}
const _hoisted_6 = {
  key: 1,
  class: "remark_content"
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = {
  key: 2,
  class: "remark_content"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.modalType === 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.existRemarks)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.allRemarkListForm.list, (item, ind) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ind + 'before'
                }, [
                  (ind === 0)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(item.remarkTitle === 'before' ? '支付前备注:' : item.remarkTitle === 'after' ? '支付后备注:': ''), 1))
                    : _createCommentVNode("", true),
                  (ind !== 0 && item.remarkTitle === 'after' && _ctx.allRemarkListForm.list[ind-1].remarkTitle === 'before')
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "支付后备注:"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.remarkName) + "：", 1),
                    (item.remarkType === 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.remarkValue || '--'), 1))
                      : _createCommentVNode("", true),
                    (item.remarkType === 2 && item.remarkValue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkValue, (img, indImg) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: ind + 'img' + indImg,
                              src: img.url,
                              width: "100",
                              height: "100",
                              class: "ant_image",
                              onClick: ($event: any) => (_ctx.handleViewImg(img.url))
                            }, null, 8, _hoisted_7))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (item.remarkType === 3)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item.remarkValue || '--'), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.myPaymentRemark || '--'), 1))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.modalType === 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.existRemarks)
            ? (_openBlock(), _createBlock(_component_a_form, {
                key: 0,
                ref: "formRef",
                model: _ctx.allRemarkListForm,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRemarkListForm.list, (item, ind) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: ind }, [
                      (ind === 0)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(item.remarkTitle === 'before' ? '支付前备注:' : item.remarkTitle === 'after' ? '支付后备注:': ''), 1))
                        : _createCommentVNode("", true),
                      (ind !== 0 && item.remarkTitle === 'after' && _ctx.allRemarkListForm.list[ind-1].remarkTitle === 'before')
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_11, "支付后备注:"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, {
                        label: item.remarkName,
                        name: ['list', ind, 'remarkValue']
                      }, {
                        default: _withCtx(() => [
                          (item.remarkType === 1)
                            ? (_openBlock(), _createBlock(_component_a_input, {
                                key: 0,
                                value: item.remarkValue,
                                "onUpdate:value": ($event: any) => ((item.remarkValue) = $event),
                                placeholder: "请输入"
                              }, null, 8, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true),
                          (item.remarkType === 2)
                            ? (_openBlock(), _createBlock(_component_a_upload, {
                                key: 1,
                                "file-list": item.remarkValue,
                                accept: ".png, .jpg, .jpeg",
                                "list-type": "picture-card",
                                "custom-request": (file) => _ctx.customRequest(file, ind),
                                remove: (file) => _ctx.removeRequest(file, ind),
                                onPreview: _ctx.handlePreview
                              }, {
                                default: _withCtx(() => [
                                  (item.remarkValue.length < (_ctx.source === 'charge' ? 8 : 6))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(_component_plus_outlined),
                                        _hoisted_13
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["file-list", "custom-request", "remove", "onPreview"]))
                            : _createCommentVNode("", true),
                          (item.remarkType === 3)
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 2,
                                value: item.remarkValue,
                                "onUpdate:value": ($event: any) => ((item.remarkValue) = $event),
                                placeholder: `请选择${item.remarkName}`
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkEnumList, (c) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, {
                                      key: c,
                                      value: c
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(c), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "name"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model", "label-col", "wrapper-col"]))
            : (_openBlock(), _createBlock(_component_a_textarea, {
                key: 1,
                value: _ctx.myPaymentRemark,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.myPaymentRemark) = $event)),
                "show-count": "",
                maxlength: 140,
                placeholder: "请输入备注内容"
              }, null, 8, ["value"]))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.previewVisible,
      footer: null,
      onCancel: _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: _ctx.previewImage
        }, null, 8, _hoisted_14)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ]))
}